import { createAction, props } from '@ngrx/store';
import { SideBarStateEnum } from 'app/shared/layout/models/side-bar-state.enum';
import { WindowSizeModel } from 'app/shared/layout/services/window-size.model';
import { ClientStatus } from 'app/shared/portal/models/client-status.model';

export const setWindowSizeChanged = createAction(
  '[UI] Set Window Size Changed',
  props<{ windowSize: WindowSizeModel }>()
);

export const setNavigationState = createAction(
  '[UI] Set Navigation State',
  props<{ navState: SideBarStateEnum }>()
);

export const setSidebarOpenState = createAction(
  '[UI] Set Sidebar Open State',
  props<{ isSBarOpen: boolean }>()
);

export const setSidebarLoadingState = createAction(
  '[UI] Set Sidebar Loading State',
  props<{ isSidebarLoading: boolean }>()
);

export const setUserIdle = createAction('[UI] Set User Idle', props<{ isIdle: boolean }>());

export const setClientStatus = createAction(
  '[UI] Set Client Status',
  props<{ clientStatus: ClientStatus | undefined }>()
);

export const setTermsId = createAction(
  '[UI] Set terms Id',
  props<{ termsId: number | undefined }>()
);
